import React from 'react';
import cx from 'classnames';
import styles from './Button.m.sass';

export default function Button({component = 'button', full, icon, iconPosition, small, extraSmall, gradient, big, price, children, ...rest}) {
  const Component = component;

  return (
    <Component
      className={cx(
        styles.btn,
        {
          [styles.btnIconed]: icon,
          [styles.btnSmall]: small,
          [styles.btnExtraSmall]: extraSmall,
          [styles.full]: full,
          [styles.gradient]: gradient,
          [styles.big]: big,
          [styles.price]: price,
        },
      )}
      {...rest}
    >
      <span className={styles.btnWrapper}>
        {icon && iconPosition === 'left' && <span className={`${styles.btnIcon} ${styles.btnIconLeft}`}><img src={icon} alt=""/></span>}
        {children}
        {icon && iconPosition === 'right' && <span className={`${styles.btnIcon} ${styles.btnIconRight}`}><img src={icon} alt=""/></span>}
      </span>
    </Component>
  );
}



// WEBPACK FOOTER //
// ./components/button/Button.js